import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSwitcherArrowActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 12 37"
    {...props}
  >
    <defs>
      <linearGradient
        id="switcher-arrow-active_svg__a"
        x1="50%"
        x2="50%"
        y1="100%"
        y2="0%"
      >
        <stop offset="0%" stopColor="#5BC9F5" />
        <stop offset="100%" stopColor="#2080F1" />
      </linearGradient>
      <filter
        id="switcher-arrow-active_svg__c"
        width="108.3%"
        height="102.7%"
        x="-4.2%"
        y="-1.4%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={1} in="SourceAlpha" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2={-1}
          k3={1}
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
      </filter>
      <path
        id="switcher-arrow-active_svg__b"
        d="M617 2983h2.435a2 2 0 0 1 1.824 1.18l7.741 17.238-7.743 17.395a2 2 0 0 1-1.827 1.187H617v-37z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(-617 -2983)">
      <use
        fill="url(#switcher-arrow-active_svg__a)"
        xlinkHref="#switcher-arrow-active_svg__b"
      />
      <use
        filter="url(#switcher-arrow-active_svg__c)"
        xlinkHref="#switcher-arrow-active_svg__b"
      />
    </g>
  </svg>
);
const Memo = memo(SvgSwitcherArrowActive);
export default Memo;
